import type { App } from "vue";
import { createI18n } from "vue-i18n";

// User defined lang
import enLocale from "./locales/en.json";
import jaLocale from "./locales/ja.json";

const messages = {
  ja: {
    ...jaLocale,
  },
  en: {
    ...enLocale,
  },
};

const getLocale = () => {
  // // Get language of session storage
  // const cookieLanguage = sessionStorage.getItem("language");
  // if (cookieLanguage) {
  //   return cookieLanguage;
  // }

  // // Get language of current browser
  // const language = navigator.language.toLowerCase();
  // const locales = Object.keys(messages);
  // for (const locale of locales) {
  //   if (language.indexOf(locale) > -1) {
  //     return locale;
  //   }
  // }
  return "ja";
};

const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  messages,
});

export const i18nGlobal = i18n.global;

// export default i18n
export default (app: App<Element>): void => {
  app.use(i18n);
};
